export const contactsData = {
    email: 'kapadnisswapnil55@gmail.com',
    phone: '+91-8956330317',
    address: 'A.P Sarde, Tal-Baglan, Dist-Nashik, Maharashtra, 423204',

    sheetAPI: ''
}